module.exports = __webpack_public_path__ + "static/education_sec2_obj2M@2x-f75262b19f6d8b0a4168f43945eb869a.png";